import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { AlertService } from 'src/app/shared/services/alert.service';
import { emailValidator } from 'src/app/validators/email.validator';
import { CommonModule } from '@angular/common';
import { FormatEmailDirective } from '../../../../directives/format-email.directive';
import { FormatPhoneUsDirective } from '../../../../directives/format-phone-us.directive';

@Component({
    selector: 'app-update-distributor-staff',
    templateUrl: './update-distributor-staff.component.html',
    styleUrls: ['./update-distributor-staff.component.scss'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FormatPhoneUsDirective, FormatEmailDirective]
})
export class UpdateDistributorStaffComponent {
  form = new FormGroup({ email: new FormControl('', [Validators.required, emailValidator()]) });
  get emailModel() { return this.form.get('email'); }

  validMail: boolean = false;
  userData: any;
  information: string = 'User ID/Account: ';
  customerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  email?: string = '';
  fieldsCompleted: boolean = false;
  masterdataRequestDTO: MasterdataRequestDTO = { idMaster: 1 };
  UserRequestDTO: UserRequestDTO = { userId: undefined };
  alert: Alert = {} as Alert;

  customer: UserDTO = {
    userAddressLine1: '', userAddressLine2: '', userCity: '', userMail: '',
    userExpirationPass: new Date('2020-05-05'), userNames: '', userPassword: '',
    userPhone: undefined, userPostalCode: undefined, userRegister: new Date('2020-05-05'),
    userState: '', userId: undefined, userStatus: undefined, numberPlans: undefined,
    numberDevices: undefined, listUserRole: [], listUserPlanDev: []
  };

  constructor(
    private router: Router,
    private alertService: AlertService,
    private customerService: CustomerService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.userData = history.state.userData;
    this.information = this.information + this.userData.userId;
    this.UserRequestDTO.userId = this.userData.userId;

    this.customerService.getCustomerById(this.UserRequestDTO).subscribe(
      ({ Data, StatusCode }) => Data != null ? this.handleGetUserByIdSuccess(Data) : this.showError(),
      () => { this.showError(); this.clearFields(); }
    );

    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ Data, StatusCode }) => Data != null ? this.states = Data : this.showError(),
      () => { this.showError(); this.clearFields(); }
    );
  }

  clearFields() {
    this.address = ''; this.contactNumber = undefined; this.customerName = '';
    this.email = ''; this.stateSelected = ''; this.zipCode = undefined; this.city = '';
  }

  goBack() { window.history.back(); }

  updateCustomer() {
    this.customer.userAddressLine1 = this.address;
    this.customer.userPhone = this.contactNumber;
    this.customer.userNames = this.customerName;
    this.customer.userMail = this.email;
    this.customer.userState = this.stateSelected;
    this.customer.userPostalCode = this.zipCode;
    this.customer.userCity = this.city;
    this.customer.listUserRole = [];
    this.customer.listUserPlanDev = [];

    this.customerService.updateCustomer(this.customer).subscribe(
      ({ Data, StatusCode }) => {
        if (Data != null) {
          this.alert = { alertMessage: 'Distributor Staff User updated successfully', alertType: 'alert alert-success', alertCenter: false, alerTitle: '', duration: 3000 };
          localStorage.setItem('AlertObject', JSON.stringify(this.alert));
          this.alertService.updateAlertState(this.alert);
          this.clearFields();
          //location.reload();
          this.navigateToDistributorStaffUsers();
        } else {
          this.showError();
        }
      },
      () => { this.showError(); }
    );
  }

  navigateToDistributorStaffUsers() {
    let distributor = {
      userId: this.userData.originalUserId,
    };
    this.router.navigate(['/distributors/distributor-staff'], {
      relativeTo: this.route,
      state: { distributorData: distributor },
    });
  }

  checkFields() {
    this.fieldsCompleted = !!(this.customerName && this.contactNumber && this.email);
  }

  checkEmailValidity() { this.validMail = !!this.emailModel?.valid; }

  handleGetUserByIdSuccess(customer: UserDTO) {
    this.customer = customer;
    this.customerName = customer.userNames;
    this.address = customer.userAddressLine1;
    this.zipCode = customer.userPostalCode;
    this.stateSelected = customer.userState;
    this.contactNumber = customer.userPhone;
    this.email = customer.userMail;
    this.city = customer.userCity;
    this.checkFields();
  }

  showError() {
    this.alert = { alertMessage: 'Unexpected error. Please try again later.', alertType: 'alert alert-danger', alertCenter: false, alerTitle: '', duration: 3000 };
    this.alertService.updateAlertState(this.alert);
  }
}
